<div class="wrapper">
  @if (!isMiniCart) {
    <a [routerLink]="cartLink" class="d-flex flex-lg-row flex-column rounded-circle app-primary-bg">
      <span class="header-cart-icon">
        <i class="fa fa-shopping-cart cursor-pointer"></i>
        <span class="header-cart-counter badge d-none d-lg-block">{{(data$|async)?.total_quantity}}</span>
      </span>
      <span class="icon-text d-lg-none">
        <span translate>Cart</span>&nbsp;
        <span>[{{(data$|async)?.total_quantity}}]</span>
      </span>
    </a>
  }
  @if (isMiniCart) {
    <a [popover]="popTemplate" #cartPopover="bs-popover" [containerClass]="!hasItems ? 'd-none' : ''" placement="bottom" [outsideClick]="true" class="d-flex flex-lg-row flex-column">
      <span class="header-cart-icon">
        <i class="fa fa-shopping-cart cursor-pointer"></i>
        <span class="header-cart-counter badge d-none d-lg-block">{{(data$|async)?.total_quantity}}</span>
      </span>
      <span class="icon-text d-lg-none">
        <span translate>Cart</span>&nbsp;
        <span>[{{(data$|async)?.total_quantity}}]</span>
      </span>
    </a>
  }
  <ng-template #popTemplate>
    <cart-summary [data]="items.Summary" [isMiniCart]="true"></cart-summary>
    <orders-layout-checkout #layoutCheckout (editCart)="onEditCart()"
      [items]="items" [isMiniCart]="true">
    </orders-layout-checkout>
    <cart-continue-actions [user]="user" [isContinueToCheckout]="isContinueToCheckout" [items]="items"></cart-continue-actions>
  </ng-template>
  @if (showCartIndication) {
    <div>
      <div [@openClose]="isOpenCartModal ? 'open' : 'closed'" class="add-to-cart-indication mat-dialog-container">
        <div class="modal-header">
          <button type="button" class="close" (click)="hideAddToCart()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-center f-s-18">
          <i class="fa fa-shopping-cart fa-2x app-primary-color"></i>
          <div class="text-cart my-3 app-primary-color">
            <span translate [innerHTML]="cartIndicationText"></span>
          </div>
        </div>
      </div>
    </div>
  }
</div>
